<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color" *ngIf="!profile">
            <h1>CREAR USUARIO</h1>
        </div>
        <div class="title-color" *ngIf="profile && !previousExist">
            <h1>EDITAR USUARIO</h1>
        </div>
        <div class="title-color" *ngIf="profile && previousExist">
            <h1>ACTIVAR USUARIO</h1>
        </div>
        <div class="form-body">
            <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
                <div *ngIf="errorMsg" class="alert alert-danger p-2 m-2">
                    <ul class="mb-0" *ngFor="let msg of errorMsg">
                        <li>
                            {{ msg }}
                        </li>
                    </ul>
                </div>
                <div
                    class="alert alert-warning p-2 m-2"
                    *ngIf="previousExist && profile"
                >
                    El usuario: {{ profile.username }} ya existe, desea
                    activarlo?
                </div>
                <div class="line">
                    <div class="column-md-3 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Número de documento</mat-label>
                            <input
                                type="text"
                                matInput
                                placeholder="Número de documento"
                                formControlName="username"
                                required
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    profileForm
                                        .get('username')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-3 column-lg-6 column-sm-12" >
                        <mat-form-field appearance="outline" >
                            <mat-label>Nombres</mat-label>
                            <input
                                type="text"
                                matInput
                                placeholder="Nombres"
                                formControlName="first_name"
                                required
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    profileForm
                                        .get('first_name')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-3 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Apellidos</mat-label>
                            <input
                                type="text"
                                matInput
                                placeholder="Apellidos"
                                formControlName="last_name"
                                required
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    profileForm
                                        .get('last_name')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-3 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Correo</mat-label>
                            <input
                                type="text"
                                matInput
                                placeholder="Correo"
                                formControlName="email"
                                required
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    profileForm
                                        .get('email')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    profileForm
                                        .get('email')
                                        ?.hasError('pattern')
                                "
                            >
                                Ingrese un correo valido
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button
                    type="submit"
                    class="primary-button"
                    *ngIf="!profile"
                    [disabled]="!profileForm.touched"
                >
                    <span class="button-content"
                        ><mat-icon fontIcon="save"></mat-icon>Crear</span
                    >
                </button>
                <button
                    type="submit"
                    class="primary-button"
                    *ngIf="profile && !previousExist"
                    [disabled]="!profileForm.touched"
                >
                    <span class="button-content"
                        ><mat-icon fontIcon="save"></mat-icon>Editar</span
                    >
                </button>
                <button
                    type="submit"
                    class="primary-button"
                    *ngIf="profile && previousExist"
                    [disabled]="!profileForm.touched"
                >
                    <span class="button-content"
                        ><mat-icon fontIcon="save"></mat-icon>Activar</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
